import React from "react";
import { Crown, Send, Check } from "lucide-react";
import Modal from "../common/Modal";
import { TELEGRAM_VIP_URL } from "../../lib/config";

const PERKS = [
  "Priority AI signal room access",
  "Verified members-only community",
  "Daily giveaway eligibility",
  "Personal risk & journal review",
];

export default function VipModal({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose} title="Join Sanjay VIP" subtitle="A private members tier for serious traders." testid="vip-modal"
      footer={
        <>
          <button onClick={onClose} className="btn-ghost rounded-xl px-5 py-2.5 font-mono text-[11px] uppercase tracking-widest">Maybe later</button>
          <a href={TELEGRAM_VIP_URL} target="_blank" rel="noreferrer" className="btn-vip flex items-center gap-2 px-5 py-2.5 font-mono text-[11px] font-bold uppercase tracking-widest" data-testid="vip-telegram-btn">
            <Send size={13} /> Open Telegram
          </a>
        </>
      }
    >
      <div className="mb-4 flex items-center gap-3 rounded-xl border border-white/10 bg-white/[0.02] p-4">
        <span className="grid h-10 w-10 place-items-center rounded-xl border border-white/10 text-[#d4d8dc]"><Crown size={18} /></span>
        <div>
          <div className="font-head text-sm font-bold uppercase tracking-tight text-white">Members Tier</div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-neutral-500">Demo mode · connect Telegram to activate</div>
        </div>
      </div>
      <ul className="space-y-2.5">
        {PERKS.map((p) => (
          <li key={p} className="flex items-center gap-3 text-sm text-neutral-300">
            <span className="grid h-5 w-5 place-items-center rounded-full border border-emerald-400/30 text-emerald-300/80"><Check size={11} /></span>
            {p}
          </li>
        ))}
      </ul>
    </Modal>
  );
}
